import { createSlice } from '@reduxjs/toolkit';
export const applicationDrillChart = createSlice({
  name: 'applicationDrillChart',
  initialState: {
    dataDoughnut: {
      labels: [],
      text: '',
      text1: '',
      cutoutPercentage: 0,
      datasets: [{
        data: [],
        backgroundColor: ['#46BFBD'],
        hoverBackgroundColor: []
      }]
    },
    applicationRiskData: []
  },
  reducers: {
    pushApplicationRiskData: (state, action) => {
      state.applicationRiskData = action.payload;

      if (state.applicationRiskData) {
        const riskScore = state.applicationRiskData.riskScore;
        const remainValue = 100 - riskScore;
        state.dataDoughnut.datasets[0].data = [riskScore, remainValue];
        const riskName = state.applicationRiskData.riskCategory;
        state.dataDoughnut.text = riskScore;
        state.dataDoughnut.text1 = riskName;

        if (riskScore >= 0 && riskScore <= 2.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#1BDC81'];
        } else if (riskScore >= 2.5 && riskScore <= 5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#19C976'];
        } else if (riskScore >= 5 && riskScore <= 7.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#14AD66'];
        } else if (riskScore >= 7.5 && riskScore <= 10) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#13A461'];
        } else if (riskScore >= 10 && riskScore <= 12.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#119256'];
        } else if (riskScore >= 12.5 && riskScore <= 15) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0F804B'];
        } else if (riskScore >= 15 && riskScore <= 17.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0D6E40'];
        } else if (riskScore >= 17.5 && riskScore <= 20) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0A5C36'];
        } else if (riskScore >= 20 && riskScore <= 22.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#084A2B'];
        } else if (riskScore >= 22.5 && riskScore <= 25) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#063720'];
        } else if (riskScore >= 25 && riskScore <= 27.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#B896ED'];
        } else if (riskScore >= 27.5 && riskScore <= 30) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#A073E7'];
        } else if (riskScore >= 30 && riskScore <= 32.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#9463E4'];
        } else if (riskScore >= 32.5 && riskScore <= 35) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#8851E1'];
        } else if (riskScore >= 35 && riskScore <= 37.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#7D40DE'];
        } else if (riskScore >= 37.5 && riskScore <= 40) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#702EDD'];
        } else if (riskScore >= 40 && riskScore <= 42.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#6623D1'];
        } else if (riskScore >= 42.5 && riskScore <= 45) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#551EAE'];
        } else if (riskScore >= 45 && riskScore <= 47.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#4D1B9E'];
        } else if (riskScore >= 47.5 && riskScore <= 50) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#44188C'];
        } else if (riskScore >= 50 && riskScore <= 52.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#7A8FF5'];
        } else if (riskScore >= 52.5 && riskScore <= 55) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#687FF4'];
        } else if (riskScore >= 55 && riskScore <= 57.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#4966F2'];
        } else if (riskScore >= 57.5 && riskScore <= 60) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#2F4FEF'];
        } else if (riskScore >= 60 && riskScore <= 62.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#1B3FEE'];
        } else if (riskScore >= 62.5 && riskScore <= 65) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#1035E4'];
        } else if (riskScore >= 65 && riskScore <= 67.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0F31D1'];
        } else if (riskScore >= 67.5 && riskScore <= 70) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0E2DBE'];
        } else if (riskScore >= 70 && riskScore <= 72.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0D27AB'];
        } else if (riskScore >= 72.5 && riskScore <= 75) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#0A2399'];
        } else if (riskScore >= 75 && riskScore <= 77.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#FFC247'];
        } else if (riskScore >= 77.5 && riskScore <= 80) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#FFB41F'];
        } else if (riskScore >= 80 && riskScore <= 82.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#FFAD0B'];
        } else if (riskScore >= 82.5 && riskScore <= 85) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#F5A300'];
        } else if (riskScore >= 85 && riskScore <= 87.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#E19600'];
        } else if (riskScore >= 87.5 && riskScore <= 90) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#CD8800'];
        } else if (riskScore >= 90 && riskScore <= 92.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#B87B01'];
        } else if (riskScore >= 92.5 && riskScore <= 95) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#A36E00'];
        } else if (riskScore >= 95 && riskScore <= 97.5) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#8F6000'];
        } else if (riskScore >= 97.5 && riskScore <= 100) {
          state.dataDoughnut.datasets[0].backgroundColor = ['#7A5200'];
        }
      }
    }
  }
});
export const {
  pushApplicationRiskData
} = applicationDrillChart.actions;
export default applicationDrillChart.reducer;